import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters, boName }) => {
    const {
        dispatchSequenceGuard,
        dispatchSequenceAnimals,
        dispatchSequenceReason,
        dispatchSequenceGroupReason,
        dispatchSequenceStreet,
        dispatchSequencePlace,
        dispatchSequenceTypePlace,
        dispatchSequenceNeighborhood,
        dispatchSequenceSector,
        dispatchSequenceTeam,
        dispatchSequenceOccurrences
    } = useReportFiltersFetch({
        fetchDispatchSequenceGuard: true,
        fetchDispatchSequenceAnimals: true,
        fetchDispatchSequenceReason: true,
        fetchDispatchSequenceGroupReason: true,
        fetchDispatchSequenceStreet: true,
        fetchDispatchSequencePlace: true,
        fetchDispatchSequenceTypePlace: true,
        fetchDispatchSequenceNeighborhood: true,
        fetchDispatchSequenceSector: true,
        fetchDispatchSequenceTeam: true,
        fetchDispatchSequenceOccurrences: true
    })

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label='Despacho'
                        isMulti={false}
                        options={[
                            {label: "Todos", value: 'all'},
                            {label: "Com atendimento", value: 'with_attendance'},
                            {label: "Sem atendimento", value: 'without_attendance'}
                        ]}
                        value={filters.dispatch}
                        onChange={(value) => setFilters(prev => ({...prev, dispatch: value}))}
                        instanceId="dispatch"
                        classNameWrapper={"w-full"}
                        isClearable={false}
                    />

                    <SelectComponent
                        label='Origem'
                        isMulti={false}
                        options={[
                            {label: "Despachado pela central", value: 'WEB_GENERATED'},
                            {label: "Despachado por fontes externas", value: 'EXTERNAL'},
                            {label: "Despachado pelo aplicativo", value: 'SELF_GENERATED'},
                            {label: "Despachado pelo responsável", value: 'LEADER_GENERATED'}
                        ]}
                        value={filters.source}
                        onChange={(value) => setFilters(prev => ({...prev, source: value}))}
                        instanceId="source"
                        classNameWrapper={"w-full"}
                        isClearable={true}
                    />

                    <SelectComponent
                        label={`${boName}`}
                        isMulti={false}
                        options={[
                            {label: "Todos", value: 'all'},
                            {label: `Com ${boName}`, value: 'WITH_BOGCM'},
                            {label: `Sem ${boName}`, value: 'WITHOUT_BOGCM'}
                        ]}
                        value={filters.bo}
                        onChange={(value) => setFilters(prev => ({...prev, bo: value}))}
                        instanceId="bo"
                        classNameWrapper={"w-full"}
                        isClearable={false}
                    />

                    <InputForm
                        label={`${boName} N°`}
                        value={filters.boNumber}
                        onChange={({target}) => setFilters(prev => ({ ...prev, boNumber: target.value }))}
                        instanceId="boNumber"
                        id="boNumber"
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />

                    <SelectComponent
                        label={`${boName} - Documentos`}
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchSequenceOccurrences ?? []}
                        value={filters.otherOccurrences}
                        onChange={(value) => setFilters(prev => ({...prev, otherOccurrences: value}))}
                        instanceId="otherOccurrences"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Contingente'
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchSequenceGuard}
                        value={filters.guard}
                        onChange={(value) => setFilters(prev => ({...prev, guard: value}))}
                        instanceId="guard"
                        classNameWrapper={"w-full"}
                    />

                    <InputForm
                        label='Guarnição'
                        value={filters.garrison}
                        onChange={({target}) => setFilters(prev => ({ ...prev, garrison: target.value?.toUpperCase() }))}
                        instanceId="garrison"
                        id="garrison"
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />

                    <SelectComponent
                        label='Animais'
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchSequenceAnimals}
                        value={filters.animals}
                        onChange={(value) => setFilters(prev => ({...prev, animals: value}))}
                        instanceId="animals"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Natureza'
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchSequenceReason}
                        value={filters.reason}
                        onChange={(value) => setFilters(prev => ({...prev, reason: value}))}
                        instanceId="reason"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Grupo de natureza'
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchSequenceGroupReason}
                        value={filters.group_reason}
                        onChange={(value) => setFilters(prev => ({...prev, group_reason: value}))}
                        instanceId="group_reason"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Logradouro'
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchSequenceStreet}
                        value={filters.street}
                        onChange={(value) => setFilters(prev => ({...prev, street: value}))}
                        instanceId="street"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Local pré-cadastrado'
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchSequencePlace}
                        value={filters.place}
                        onChange={(value) => setFilters(prev => ({...prev, place: value}))}
                        instanceId="place"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Tipo de local'
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchSequenceTypePlace}
                        value={filters.type_place}
                        onChange={(value) => setFilters(prev => ({...prev, type_place: value}))}
                        instanceId="typePlace"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Bairro'
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchSequenceNeighborhood}
                        value={filters.neighborhood}
                        onChange={(value) => setFilters(prev => ({...prev, neighborhood: value}))}
                        instanceId="neighborhood"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Setor'
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchSequenceSector}
                        value={filters.sector}
                        onChange={(value) => setFilters(prev => ({...prev, sector: value}))}
                        instanceId="sector"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Equipe'
                        isMulti={true}
                        wrapValues={true}
                        options={dispatchSequenceTeam}
                        value={filters.team}
                        onChange={(value) => setFilters(prev => ({...prev, team: value}))}
                        instanceId="team"
                        classNameWrapper={"w-full"}
                    />

                    <div className={"mb-2 ml-1"}>
                        <InputCheckbox
                            id="hasScheduleOnly"
                            label="Somente atividades programadas"
                            checked={filters.hasScheduleOnly}
                            onChange={(e) => setFilters(prev => ({...prev, hasScheduleOnly: e.target.checked}))}
                        />
                    </div>

                    <div className={"mb-6 ml-1"}>
                        <InputCheckbox
                            id="showDisplacement"
                            label="Exibir deslocamento"
                            checked={filters.showDisplacement}
                            onChange={(e) => setFilters(prev => ({...prev, showDisplacement: e.target.checked}))}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;